const initialState = {
  modalDeleteData: {
    emableModel: false,
    message: "",
    enableCancleButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
  searchOptions: {},
  searchResults: [],
  allData: [],
  currentApiData: "",
  searchResults: {},
  selectedApiKey: null,
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  tableLoading: false,
  sidebarLoading: false,
  modalLoading: false,
  showApiModel: false,
  usageEndpointLoading: false,
  usageMethodLoading: false,
  usageLocationLoading: false,
  usageEndpointData: {},
  usageMethodData: {},
  usageLocationData: {},
};

const ApiKeyReducer = (state = initialState, action) => {
  const { type, payload, data, id } = action;

  switch (type) {
    case "SET_SEARCH_OPTIONS":
      return {
        ...state,
        searchOptions: action.data,
      };
    case "SET_SEARCH_RESULTS_API_KEY":
      return {
        ...state,
        searchResults: data.content,
        totalItems: data.totalItems,
        totalPages: data.totalPages,
        currentPage: data.page,
      };
    case "SET_API_DATA":
      return {
        ...state,
        // allData: Array.isArray(data.data.content) ? data.data.content : [],
        allData: Array.isArray(data) ? data : [],
      };

    case "ADD_API_KEY":
      return {
        ...state,
        currentApiData: payload,
        // allData: [...state.allData, payload],
        // total: state.total + 1,
      };

    case "SET_SINGLE_API_KEY":
      return {
        ...state,
        selectedApiKey: data,
      };

    case "DELETE_API_KEY":
      return {
        ...state,
        allData: state.allData.filter((item) => item.id !== id),
        searchResults: state.searchResults.filter((item) => item.id !== id),
        total: state.total - 1,
      };
    case "OPEN_MODEL_DELETE":
      return {
        ...state,
        modalDeleteData: action.value,
      };
    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload,
      };

    case "OPEN_MODEL_API":
      return {
        ...state,
        showApiModel: action.value,
      };

    case "SET_MODAL_LOADING":
      return {
        ...state,
        modalLoading: payload,
      };
    case "SET_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload,
      };

    case "FILTER_API_DATA":
      let value = action.value;
      let filteredData = [];
      if (value.length) {
        filteredData = state.allData.filter((item) => {
          let startsWithCondition =
            item.name.toLowerCase().startsWith(value.toLowerCase()) ||
            item.organisationName.toLowerCase().startsWith(value.toLowerCase());

          let includesCondition =
            item.name.toLowerCase().includes(value.toLowerCase()) ||
            item.organisationName.toLowerCase().includes(value.toLowerCase());

          if (startsWithCondition) {
            return startsWithCondition;
          } else if (!startsWithCondition && includesCondition) {
            return includesCondition;
          } else return null;
        });
        // .slice(state.params.page - 1, state.params.perPage)
        return {
          ...state,
          filteredData,
        };
      } else {
        filteredData = state.data;
        return { ...state, filteredData };
      }

    case "SET_API_KEY_USAGE_LOADING":
      const { key: loaderKey, value: loaderValue } = payload;
      return {
        ...state,
        [loaderKey]: loaderValue,
      };
    case "SET_ENDPOINT_USAGE_DATA":
      return { ...state, usageEndpointData: payload };
    case "SET_METHOD_USAGE_DATA":
      return { ...state, usageMethodData: payload };
    case "SET_LOCATION_USAGE_DATA":
      return { ...state, usageLocationData: payload };

    default:
      return state;
  }
};

export default ApiKeyReducer;
